// These are the types for the v2 api
// Import existing types that we'll extend
import { 
  // This is the base type I am using for backward compatibility,
  // but plan is to remove this completely in future and have base type 
  // similar to the golang types. But it's used across multiple places,
  // so will do that in increments.
  CheckupRequestInfo,
} from './apiTypes';
import { ValidatedPageDefinition } from './checkupWorkflow/schema';

// Include options for the v2 API - these correspond to the Go CRequestIncludes enum
export enum CheckupRequestInclude {
  VET = 'vet',
  PET = 'pet', 
  CLINIC = 'clinic',
  STATUS = 'status',
  TYPE = 'type',
  ITEMS = 'items'
}

export type CheckupUI = {
    pages: ValidatedPageDefinition[];
};

export type CheckupRequestV2TypeInclude = {
    checkup_type: {
      id: string;
      name: string;
      ui: CheckupUI;
    };
};

export type CheckupRequestV2Response = CheckupRequestInfo & 
  CheckupRequestV2TypeInclude;

// Utility function to convert CheckupRequestV2Response to CheckupRequestInfo
// Use type casting when you know all required fields are present as I am currently
// passing all the includes so this should be safe, and only used when v2 api is called.
export const ConvertCheckupRequestV2ResponseToInfo = (response: CheckupRequestV2Response): CheckupRequestInfo => {
  return response as unknown as CheckupRequestInfo;
};
